export default __webpack_public_path__ + "static/media/698.246c8c41.gif";